<template>
  <div>
    <Profile></Profile>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const Profile = defineAsyncComponent(() => import("@/components/auth/Profile"));
export default {
  components: {
    Profile,
  },
};
</script>
